import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { deleteQueryParams, getQueryParams } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import { oldApiInstance } from 'functions/request';
import ROUTES from 'consts/routes';
import trackGoogleTagEvent from 'functions/trackGoogleTagEvent';
import CConsole from 'functions/CConsole';
import { getWallet } from 'store/user/selectors';
import useAction from 'hooks/useAction';
import { pushBackPaypalConfirmModal, pushBackPaypalDisconnectModal } from 'store/modals/actions';
import { fetchUser } from 'store/user/actions';
import { showErrorAlert } from 'store/alerts/actions';

export const usePayPalConnectListener = () => {
  const fetchUserFunc = useAction(fetchUser);
  const showErrorAlertFunc = useAction(showErrorAlert);

  useEffect(() => {
    const { code, error } = getQueryParams([QUERY_PARAMS.code, QUERY_PARAMS.error]);

    if (code) {
      oldApiInstance
        .post(ROUTES.api.paypalConnectPath, { code })
        .then(() => {
          trackGoogleTagEvent('connectpaypal');
          window.postMessage('receivePaypalAccount', '*');
          fetchUserFunc();
          deleteQueryParams([QUERY_PARAMS.code, QUERY_PARAMS.scope]);
        })
        .catch(err => {
          const { response } = err;

          if (response.data && response.data.error) {
            const serverError = response.data.error[0];

            showErrorAlertFunc({ message: serverError.err || serverError });
          }
          CConsole.error(err);
        });

      return;
    }

    if (error) {
      deleteQueryParams([QUERY_PARAMS.error, QUERY_PARAMS.errorDescription, QUERY_PARAMS.errorUri]);
    }
  }, []);
};

export const usePayPalButtons = () => {
  const { paypal_account: payPalAccount } = useSelector(getWallet);
  const pushBackPaypalDisconnectModalFunc = useAction(pushBackPaypalDisconnectModal);
  const pushBackPaypalConfirmModalFunc = useAction(pushBackPaypalConfirmModal);

  const verifyHandler = useCallback(() => {
    pushBackPaypalConfirmModalFunc();
  }, []);

  const connectHandler = useCallback(() => {
    const redirectUri = encodeURIComponent(window.location.origin + window.location.pathname);

    window.location.href = `${process.env.REACT_APP_PAYPAL_CONNECT_URL}?flowEntry=lg&client_id=${process.env.REACT_APP_PAYPAL_APP_ID}&response_type=code&scope=openid%20profile%20email%20https%3A%2F%2Furi.paypal.com%2Fservices%2Fpaypalattributes&redirect_uri=${redirectUri}`;
  }, []);

  const disconnectHandler = useCallback(() => {
    pushBackPaypalDisconnectModalFunc();
  }, []);

  return {
    verify: {
      condition: !!(payPalAccount && !payPalAccount.confirmed),
      handler: verifyHandler,
    },
    connect: {
      condition: !payPalAccount,
      handler: connectHandler,
    },
    disconnect: {
      condition: !!payPalAccount?.confirmed,
      handler: disconnectHandler,
    },
  };
};
